module.exports = __webpack_public_path__ + "static/Omnivore-f350b3af3e44e142c9fdc84f2aec8ccd.jpg";